<template>
    <div class="content" type="false">
        <headers_m></headers_m>
        <img :src="$t('index_mobile').gif" class="video" alt="" />
        <div class="live" @click="inLive">{{ $t("live").live }}</div>
        <div class="toast" v-show="toastShow">
            {{ toastText }}
        </div>
        <div class="footer_mobile">
            Copyright 2021 mi.com . All Rights Reserved. 京ICP备18018739号-1
        </div>
    </div>
</template>

<script>
import headers_m from "../components/headers_m.vue";
import wx from "weixin-js-sdk";
export default {
    components: {
        headers_m,
    },
    name: "index",
    data() {
        return {
            lang: "",
            play: false,
            toastText: "",
            toastShow: false,
            token:''
        };
    },
    created() {
        let lang = localStorage.getItem("lang");
        this.$i18n.locale = this.lang = lang;
    },
    mounted() {
        if (wx) {
            if (this.isAndroid()) {
                this.play = false;
            } else {
                this.play = true;
            }
        }
    },
    methods: {
        isAndroid() {
            let UA = navigator.userAgent;
            if (UA.match(/iPad/) || UA.match(/iPhone/) || UA.match(/iPod/)) {
                return true;
            } else {
                return false;
            }
        },
        inLive() {
            let that = this;
            that.token = localStorage.getItem("token");
            if (that.token == "" || that.token == null) {
                that.toast(that.$t("signUp").login_tips);
                setTimeout(() => {
                    that.$router.replace("/login").catch(() => {});
                }, 1500);
                return;
            } else {
                that.rq.post("/user/userinfo").then((res) => {
                    if (res.code == "1") {
                        localStorage.setItem(
                            "sign",
                            res.data.userinfo.audit_status
                        );
                        if (res.data.userinfo.audit_status == 1) {
                            that.toast(that.$t("personal").tips3);
                        } else if (res.data.userinfo.audit_status == 2) {
                            that.$router.replace("/live").catch(() => {});
                        } else if (res.data.userinfo.audit_status == 3) {
                            that.toast(that.$t("personal").tips2);
                        }
                    }
                });
            }
        },
        toast(str) {
            let that = this;
            that.toastText = str;
            that.toastShow = true;
            setTimeout(function () {
                that.toastShow = false;
            }, 1600);
        },
    },
};
</script>
<style scoped>
.content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.video {
    width: 100%;
    flex: 1;
    /* height: 100%; */
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
}

.play {
    width: 100px;
    position: fixed;
    left: 50%;
    top: 50%;
    z-index: 10;
    transform: translate(-50%, -50%);
}
.live {
    width: 306px;
    position: absolute;
    bottom: 320px;
    left: calc((100vw - 306px) / 2);
    height: 90px;
    background: url(../assets/live.png) no-repeat;
    transform: scale(0.8);
    text-align: center;
    font-size: 30px;
    letter-spacing: 3px;
    line-height: 90px;
    color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/views/index.vue